import { useFragment } from '@frameio/graphql-client';
import type {
  Resource,
  ResourceNameFragment,
} from '@frameio/graphql-client/generated';
import { ResourceName } from '@frameio/graphql-client/generated';
import { getResourceName } from '../utils';

/**
 * Attempts to retrieve the name of a resource from the Apollo Client cache.
 */
export const useResourceName = (
  resourceId: Resource['id'],
  resourceType: string
) => {
  const resource = useFragment<ResourceNameFragment>({
    fragment: ResourceName,
    fragmentName: 'ResourceName',
    from: {
      __typename: resourceType ?? '',
      id: resourceId ?? '',
    },
  });
  const resourceName = getResourceName(resource?.data);
  return resourceName;
};
